import React from "react";
import { StyledDemoCard } from "./styled";

interface Props {
  visuals: string;
  title: string;
  description: string;
  index: number;
}

const DemoItem: React.FC<Props> = ({ visuals, title, description, index }) => {
  return (
    <StyledDemoCard index={index} className="demo-col">
      <div className="visual-area">
        <img src={visuals} alt={`feature_${index + 1}`} />
      </div>
      <div className="text-area">
        <h1>{title}</h1>
        <span>{description}</span>
      </div>
    </StyledDemoCard>
  );
};

export default DemoItem;
